var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCustomSmallGreyClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_17137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6499 14.72C20.6499 16.68 20.1299 18.53 19.2099 20.12C17.2899 21.83 14.7599 22.87 11.9999 22.87C5.99988 22.87 1.12988 18 1.12988 12C1.12988 10.03 1.65988 8.17999 2.56988 6.58999C4.48988 4.89999 7.01988 3.85999 9.77988 3.85999C12.7799 3.85999 15.4999 5.07999 17.4699 7.03999C19.4299 8.99999 20.6499 11.72 20.6499 14.72Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.33 3.67998C18.1 1.45998 15.14 0.22998 12 0.22998C8.85998 0.22998 5.89998 1.45998 3.66998 3.67998C2.92998 4.42998 2.29998 5.24998 1.78998 6.13998C0.76998 7.91998 0.22998 9.94998 0.22998 12C0.22998 18.49 5.50998 23.77 12 23.77C14.88 23.77 17.65 22.71 19.78 20.81C19.97 20.65 20.16 20.48 20.32 20.31C22.54 18.09 23.76 15.14 23.76 11.99C23.76 8.83998 22.55 5.90998 20.33 3.67998ZM19.05 19.04C18.92 19.17 18.78 19.3 18.61 19.44C16.78 21.07 14.44 21.96 12 21.96C6.49998 21.96 2.02998 17.49 2.02998 11.99C2.02998 10.25 2.48998 8.53998 3.34998 7.02998C3.77998 6.27998 4.31998 5.57998 4.94998 4.94998C6.82998 3.06998 9.33998 2.02998 12 2.02998C14.66 2.02998 17.17 3.06998 19.05 4.95998C20.93 6.83998 21.97 9.33998 21.97 12C21.97 14.66 20.94 17.16 19.05 19.04Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9001 11.79V6.43003C12.9001 5.93003 12.5001 5.53003 12.0001 5.53003C11.5001 5.53003 11.1001 5.93003 11.1001 6.43003V12C11.1001 12.03 11.1101 12.05 11.1201 12.08C11.1001 12.34 11.1701 12.6 11.3701 12.8L15.3101 16.73C15.4701 16.91 15.7001 17 15.9401 17C16.1801 17 16.4001 16.91 16.5801 16.74C16.9301 16.39 16.9301 15.82 16.5801 15.47L12.9001 11.79Z",
    fill: "#404040"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_17137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCustomSmallGreyClock);
export default __webpack_public_path__ + "static/media/Icon-Custom-Small-Grey-Clock.52c24ad9b42ca8af6c59c3f0c9d81b7f.svg";
export { ForwardRef as ReactComponent };